import { getStaticProps as pageGetStaticProps } from '@/pages/[[...slug]]'
export { default, getStaticPaths } from '@/pages/[[...slug]]'

export function getStaticProps(ctx: any) {
  return pageGetStaticProps({ ...ctx, locale: 'en' })
}
